import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

type UseKnowledgeCrawlSchedulesQueryOptions = {
  databaseId: string | undefined;
  enabled: boolean;
};

export function useKnowledgeCrawlSchedulesQuery({
  databaseId,
  enabled,
}: UseKnowledgeCrawlSchedulesQueryOptions) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user) && Boolean(databaseId);

  return useQuery({
    queryKey: knowledgeQueryKeys.crawlSchedules(databaseId ?? ''),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listCrawlSchedules(databaseId!),
  });
}
